import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";

export class LockMaxWinSymbols implements SimplePresentation {

    shouldRun(): boolean {
        return FlightMode.reelView.getMaxWinSymbols().some((symbol) => symbol.unlocked);
    }

    public start(controller:SimplePresentationRunnerController):void {
        gsap.timeline()
            .add(FlightMode.reelView.getMaxWinSymbols()
                .filter((symbol) => symbol.unlocked)
                .map((symbol) => symbol.lockMaxWin()))
            .add(() => {
                controller.finish();
            }, '>0.1');
    }
}
